import React, { type ReactElement } from 'react';
import config from 'react-global-configuration';

import type { SiteDomain } from '../../types';

export interface DomainChooserProps {
  domains: Partial<Record<SiteDomain, ReactElement | null>>;
  fallback?: ReactElement;
}

const DomainChooser: React.FC<DomainChooserProps> = (props) => {
  const { domains, fallback } = props;
  const currentDomain = config.get('CURRENT_DOMAIN') as SiteDomain;

  // If we have a rendering specified for currentDomain,
  // render that, even if the result is intended as null.
  if (currentDomain in domains) {
    return domains[currentDomain] || null;
  }

  // If a fallback has been given and currentDomain is not
  // specified, use the fallback instead.
  if (fallback) {
    return fallback;
  }

  return null;
};

export default DomainChooser;
